export default __webpack_public_path__ + "static/media/Icons-Website-Global.3b676191.svg";